<template>
  <Card shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2'}" :padding="0">
    <Poptip placement="left" style="float:right;" v-model="visiblePopTip">
      <Icon v-if="hasOptions" type="android-more-vertical" style="font-size:1.4em;padding:10px;"></Icon>
      <div class="permission" slot="content" v-if="userPermission">
        <div v-for="(permission, indx) in permissions" :key="indx"
          v-if="permission.value != userPermission.permission">
          <p style="padding-bottom: 10px;" v-on:click="setPermission(permission.value, 'update')">
            {{permission.label}}
          </p>
        </div>
      </div>
      <div class="permission" slot="content" v-if="!userPermission">
        <div v-for="(permission, indx) in permissions" :key="indx"
          v-if="permission.value != '1'">
          <p style="padding-bottom: 10px;" v-on:click="setPermission(permission.value, 'add')">
            {{permission.label}}
          </p>
        </div>
      </div>
    </Poptip>
    <Icon @click="showRemoveUserConfirmation(item.id,careplan.id)"  v-if="(visibleRemoveMember(userPermission)) && hasOptions && careplan && careplan.id && careplan.type != 'event'" type="ios-trash-outline" style="font-size:1.4em;padding:10px 5px;float:right"></Icon>
    <div class="resources-item-header" :style="{padding: '10px 10px 8px'}" @click="viewUser(item)">
      <!-- <Icon v-if="showArrow" type="chevron-right" style="float:right;line-height:40px"></Icon> -->
      <slot name="sub-avatar">
        <Avatar shape="circle" size="large" :src="userDisplayImage(item)"  :style="{float:'left', marginRight: '10px', background: '#ddd'}" />
      </slot>
      <p>
        <slot name="sub-name"><b>{{item.display_name}}</b>
        </slot>
      </p>
      <slot name="sub-title">
        <small style="color:#aaa;height:20px;display:block;min-width:100px" v-if="userPermission">
          {{this.getUserLabel(userPermission.permission,item)}}
        </small>
        <small style="color:#aaa;height:20px;display:block;min-width:100px" v-if="!userPermission">
          <!-- Member -->
          {{item.city || item.province || item.region || item.country}}
        </small>
      </slot>
    </div>
    <span v-if="careplan && careplan.type == 'event' && item.is_going" style="color:#2d8cf0;font-size: 15px;position:absolute;top:0px;right:15px;line-height:59px">
      <i class="fas fa-check-circle"></i>
    </span>
  </Card>
</template>

<script>
import Utils from '@/utils.js'
export default {
  name: 'UserListItemComponent',
  props: {
    item: {
      required: true
    },
    hasOptions: {
      type: Boolean,
      default: false
    },
    userPermission: {
      type: [Object],
      default: function () {

      }
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    careplan: {
      type: [Object]
    }
  },
  data(){
    return {
      permissions: [{
          value: '503',
          label: 'Admin'
        }, {
          value: '99',
          label: 'Moderator'
        }, {
          value: '49',
          label: 'Editor'
        }, {
          value: '1',
          label: 'Member'
        }, {
          value: '16',
          label: 'Author'
        }
      ],
      allPermissions: [{
          value: '503',
          label: 'Admin'
        }, {
          value: '99',
          label: 'Moderator'
        }, {
          value: '49',
          label: 'Editor'
        }, {
          value: '1',
          label: 'Member'
        }, {
          value: '16',
          label: 'Author'
        }, {
          value: '0',
          label: 'Admin'
        }, {
          value: '511',
          label: 'Admin'
        }
      ],
      visiblePopTip: false,
    }
  },
  methods: {
    viewUser (item) {
      this.$emit('userClick');
      this.$router.push({ path: '/profile/' + item.id })
    },
    getPermissionLabel(permissionCode) {
      // if(permissionCode){
        for(let i = 0; i < this.allPermissions.length; i++){
          if(permissionCode == this.allPermissions[i].value){
            return (this.allPermissions[i].label)
          }
        }
      // }
    },
    setPermission(permissionCode, type) {
      this.visiblePopTip = false;
      this.$emit('emitPermission', {value: permissionCode, type: type})
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    visibleRemoveMember(permission){
      if(permission && permission.permission){
        if(this.getPermissionLabel(permission.permission) != "Admin"){
          return true
        }else{
          return false
        }
      }else{
        return true;
      }
    },
    getUserLabel(permissionCode,item){
        if(this.getPermissionLabel(permissionCode) == "Member"){
          return item.city || item.province || item.region || item.country
        }else{
          return this.getPermissionLabel(permissionCode)
        }
    },
    removeMember(userId,groupId){
      this.$store.dispatch('resource/removeUserFromGroup',{
          userId:userId,
          groupId:groupId
        }).then(res=>{
          this.removeMemberById(userId)
        },error =>{
          console.log('error removed user',error)
        });
    },
    removeMemberById(ids){
      var index = this.subscribers.subscribers.map(x => {
        return x.id;
      }).indexOf(ids);
        this.subscribers.subscribers.splice(index, 1);
    },
    showRemoveUserConfirmation: function(userId, groupId) {
      this.$Message({
        closable: true,
        title: { content:'Confirm' },
        icon: 'ios-trash',
        message: { content: 'Are you sure you want to remove ' + this.item.display_name + '?' },
        buttons: [
          { label: 'Remove', type: 'error', hideAfter:true, action: ()=> this.removeMember(userId, groupId) },
          { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });
    },
  },
  computed:{
      subscribers: {
        get () {
          return this.$store.state.resource.singleResource.subscribers
        }
      }
  }
}
</script>
